/* @ngInject */
function ContactFactory($http, $rootScope, TrackingStateService) {
  class Contact {
    constructor(data) {
      this.smartVaultId = null;
      this.smartVaultUuid = null;
      this.firstName = null;
      this.middleName = null;
      this.lastName = null;
      this.email = null;
      this.emailIsActive = null;

      if (data) this.setData(data);
    }

    static getResourceUrl() {
      return `${process.env.SERVER_URL}/api/secure/organization/${$rootScope.organization.slug}/contacts`;
    }

    setData(data) {
      if (angular.isString(data)) {
        this._id = data;
        return;
      }

      this.smartVaultId = data.smartVaultId;
      this.smartVaultUuid = data.smartVaultId;
      this.emailIsActive = data.emailIsActive || !data.smartVaultId;
      this.firstName = data.firstName;
      this.firstNameCanonical = data.firstNameCanonical;
      this.middleName = data.middleName;
      this.lastName = data.lastName;
      this.email = data.email;
    }

    isNew() {
      return !this._id;
    }

    sendPartial() {
      return {
        firstName: this.firstName,
        middleName: this.middleName,
        lastName: this.lastName,
        appointment: this.appointment,
        company: this.company,
        nif: this.nif,
        email: this.email,
        primaryPhone: this.primaryPhone,
        secondaryPhone: this.secondaryPhone,
        addressLine1: this.addressLine1,
        addressLine2: this.addressLine2,
        city: this.city,
        stateOrProvince: this.stateOrProvince,
        country: this.country,
        zipOrPostalCode: this.zipOrPostalCode,
        currency: this.currency,
      };
    }

    fullName() {
      return `${this.firstName}${
        this.middleName ? ` ${this.middleName}` : ""
      } ${this.lastName || ""}`.trim();
    }

    fullNameAndEmail() {
      return `${this.fullName()} (${this.email})`;
    }

    static query(params) {
      return $http
        .get(Contact.getResourceUrl(), { params })
        .then((response) =>
          response.data.map((contactData) => new Contact(contactData))
        );
    }

    save() {
      return this.isNew() ? this.create() : this.update();
    }

    create() {
      if (!this.isNew()) throw new Error("The contact is already created");

      TrackingStateService.trackCustomEvent("new-contact");
      return $http
        .post(Contact.getResourceUrl(), this.sendPartial())
        .then((response) => this.setData(response.data));
    }

    update() {
      if (this.isNew())
        throw new Error("Can not update a contact that has not been created");

      return $http
        .put(`${Contact.getResourceUrl()}/${this._id}`, this.sendPartial())
        .then((response) => this.setData(response.data));
    }

    delete() {
      if (this.isNew())
        throw new Error("Can not delete a contact that has not been created");

      return $http
        .delete(`${Contact.getResourceUrl()}/${this._id}`)
        .then(() => true);
    }
  }

  return Contact;
}

export default ContactFactory;
